export default __webpack_public_path__ + "static/media/QPronouncia-removebg-preview.a1aadef1.png";